// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserAccessManagementFilledSvg from "@fishx/icons-svg/es/asn/UserAccessManagementFilled";
import FishxIcon from '../components/FishxIcon';

var UserAccessManagementFilled = function UserAccessManagementFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserAccessManagementFilledSvg
  }));
};

UserAccessManagementFilled.displayName = 'UserAccessManagementFilled';
export default React.forwardRef(UserAccessManagementFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserAccessManagementFilled.js
// module id = 4342
// module chunks = 0